module.exports = __webpack_public_path__ + "static/media/destapa.823522a6.jpg";